import { getAllPcbs, getPcbCostByID, getPcb, getPcbSpecValues, savePcbSpecValues, createPcb, updatePcb, deletePcb, getPcbCostsByPcb, createPcbCost, deletePcbCost, getPcbByName, calculatePcbPrice, getPcbCalculate, savePcbCalculate, createPcbCalculate, getCalculateHistory, getPcbList, deletePcbListInfo } from '@/api/pcb'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    loadAllPcbs: ({ commit }) => {
      return getAllPcbs().then(resp => {
        return resp
      })
    },
    loadPcbCostEstimator: ({ commit }, id) => {
      return getPcbCostByID(id).then(resp => {
        return resp
      })
    },
    loadPcb: ({ commit }, id) => {
      return getPcb(id).then(resp => {
        return resp
      })
    },
    loadPcbSpecValues: ({ commit }, id) => {
      return getPcbSpecValues(id).then(resp => {
        return resp
      })
    },
    savePcbSpecValues: ({ commit }, { id, data }) => {
      return savePcbSpecValues(id, data).then(resp => {
        return resp
      })
    },
    createPcb: ({ commit }, data) => {
      return createPcb(data).then(resp => {
        return resp
      })
    },
    updatePcb: ({ commit }, { id, data }) => {
      return updatePcb(id, data).then(resp => {
        return resp
      })
    },
    deletePcb: ({ commit }, id) => {
      return deletePcb(id)
    },
    loadPcbCostsByPcb: ({ commit }, pcbId) => {
      return getPcbCostsByPcb(pcbId).then(resp => {
        return resp
      })
    },
    createPcbCost: ({ commit }, data) => {
      return createPcbCost(data).then(resp => {
        return resp
      })
    },
    deletePcbCost: ({ commit }, id) => {
      return deletePcbCost(id).then(resp => {
        return resp
      })
    },
    getPcbByName: ({ commit }, boardName) => {
      return getPcbByName(boardName).then(resp => {
        return resp
      })
    },
    calculatePcbPrice: ({ commit }, { pcbId, data }) => {
      return calculatePcbPrice(pcbId, data).then(resp => {
        return resp
      })
    },
    getPcbCalculate: ({ commit }, pcbId) => {
      return getPcbCalculate(pcbId).then(resp => {
        return resp
      })
    },
    savePcbCalculate: ({ commit }, { pcbCostId, data }) => {
      return savePcbCalculate(pcbCostId, data).then(resp => {
        return resp
      })
    },
    createPcbCalculate: ({ commit }, data) => {
      return createPcbCalculate(data).then(resp => {
        return resp
      })
    },
    getCalculateHistory: ({ commit }, pcbId) => {
      return getCalculateHistory(pcbId).then(resp => {
        return resp
      })
    },
    getPcbList: ({ commit }, data) => {
      return getPcbList(data).then(resp => {
        return resp.data
      })
    },
    deletePcbListInfo: ({ commit }, pcbId) => {
      return deletePcbListInfo(pcbId).then(resp => {
        return resp
      })
    }
  }
}
